import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import * as Types from '../types';
import { QUESTIONNAIRE_POPUP_ID } from '../constants';
import { QuestionnairePopup } from '../QuestionnairePopup';

export const showQuestionnairePopupAction = (
    {
        id = QUESTIONNAIRE_POPUP_ID,
        title,
        onClose,
        onSuccess,
        formName,
        tkPrefix,
        daydepositlimit,
        weekdepositlimit,
        monthdepositlimit
    }: Types.IQuestionnairePopupProps
) => addPopupAction({
    id,
    title,
    onClose,
    tkPrefix,
    formName,
    onSuccess,
    daydepositlimit,
    weekdepositlimit,
    monthdepositlimit,
    closeAll: true,
    layer: LAYER.COMMON,
    component: QuestionnairePopup
});
